export enum UserOrganisationClaimStatusEnum {
  PENDING = "pending",
  EXPIRED = "expired",
  DECLINED = "declined",
  APPROVED = "approved",
  PENDING_AUTHORISATION = "pending_authorisation",
}
